module.exports = {
      id: "whitedownarrow-usage",
      viewBox: "0 0 330 330",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#whitedownarrow",
      toString: function () {
        return this.url;
      }
    }